/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
/* eslint-disable sort-keys */

/**
 * Behance avatar domain-environment mapping
 */
const BEHANCE_STAGE = 'https://cc-api-behance-stage.adobe.io';
const BEHANCE_PROD = 'https://cc-api-behance.adobe.io';
export const behanceAvatarDomain = {
  test: BEHANCE_STAGE,
  dev: BEHANCE_STAGE,
  qa: BEHANCE_STAGE,
  stage: BEHANCE_STAGE,
  prod: BEHANCE_PROD
};

/**
 * Experience Cloud domain-environment mapping
 */
const LOGIN_STAGE = 'https://exc-loginims.experience-qa.corp.adobe.com';
const LOGIN_PROD = 'https://exc-loginims.experiencecloud.adobe.com';
export const excDomain = {
  test: LOGIN_STAGE,
  dev: LOGIN_STAGE,
  qa: LOGIN_STAGE,
  stage: LOGIN_STAGE,
  prod: LOGIN_PROD
};

/**
 * IMS Validate Token scheduler default interval in millis
 */
export const validateTokenDefInterval = 30000;

/**
 * IMS Validate Token scheduler min interval in millis
 */
export const validateTokenMinInterval = 5000;

/**
 * Metrics Auth logger name mapping
 */
export const excAuth = 'exc.auth.Auth';
